import React, { useState } from "react";
import { useAuth } from "context/AuthContext";
import { Grid2, Fab, Box, useTheme, Select, Menu, MenuItem } from "@mui/material";
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CommentIcon } from "assets/PwC_Funct_Icons_Comment_Fill_Black_RGB.svg";
import {ReactComponent as Logo} from "assets/images/pwc.svg"
import { ReactComponent as ArrowDropDownCircleIcon } from "assets/PwC_Funct_Icons_ChevronDown_Outline_Black_RGB.svg"
import { ReactComponent as ArrowUpIcon } from "assets/PwC_Funct_Icons_ArrowUp_Outline_Black_RGB.svg"
import { height, width } from "@mui/system";
import { ReactComponent as SpeakerIcon } from "assets/PwC_Funct_Icons_VolumeUp_Outline_Black_RGB.svg"
import {ReactComponent as LikeIcon} from "assets/PwC_Funct_Icons_ThumbsUp_Outline_Black_RGB.svg"
import {ReactComponent as DislikeIcon} from "assets/PwC_Funct_Icons_ThumbsDown2_Outline_Black_RGB.svg"
import {ReactComponent as MicroPhoneIcon} from "assets/PwC_Funct_Icons_Microphone_Outline_Black_RGB.svg"
import {ReactComponent as RefreshIcon} from "assets/PwC_Funct_Icons_RotateClockwise_Outline_Black_RGB.svg"



const PwcCopilot = ({open, setOpen}) => {
    const [dropdownValue, setDropdownValue] = useState("assistant");
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const { setAuthenticated, user } = useAuth();
    const theme = useTheme();


    const getUserName = () => {
    const fullName = `${user?.firstName} ${user?.lastName}`;
    return fullName
    }


    const CustomDropdownIcon = (props) => (
        <ArrowDropDownCircleIcon
            {...props}
            style={{ height: "20px", width: "20px", fill: "#383432" }}
        />
    );

    const handleSend = () => {
        if (message.trim() === "") return;


        setMessages((prev) => [...prev, { sender: "user", text: message }]);


        setMessage("");


        setTimeout(() => {
            setMessages((prev) => [
                ...prev,
                { sender: "bot", text: `Response to: ${message}` }
            ]);
        }, 500);
    };


    return (
        <>
            {open && (
                <Box
                    sx={{
                        position: "fixed",
                        top: 65,
                        right: 0,
                        height: { xs: "calc(100vh - 65px)", sm: "660px" },
                        width: { xs: "100%", sm: "25%" },
                        background: "white",
                        borderLeft: "2px solid #ccc",
                        zIndex: 1300001,
                        display: "flex",
                        flexDirection: "column",
                        boxShadow: "-2px 0px 10px rgba(0,0,0,0.2)",
                        backgroundColor: "#FFFFFF"
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px",
                        }}
                    >
                        <Box>
                            <Logo />
                        </Box>
                        <Box>
                            <Select
                                value={dropdownValue}
                                onChange={(e) => setDropdownValue(e.target.value)}
                                size="small"
                                variant="standard"
                                disableUnderline
                                IconComponent={CustomDropdownIcon}
                                sx={{
                                    minWidth: 71,
                                    "& .MuiSelect-icon": {
                                        top: "50%",
                                        transform: "translateY(-50%)", 
                                    },
                                }}
                                MenuProps={{ disablePortal: true }}
                            >
                                <MenuItem value="assistant" sx={{ fontWeight: 400, color: "#000000" }}>Ai Assistant</MenuItem>
                                <MenuItem value="support" sx={{ fontWeight: 400, color: "#000000" }}>Support</MenuItem>
                            </Select>
                        </Box>

                        <CrossIcon
                            style={{ height: "20px", width: "20px", fontWeight: 500, fill: "#383432", cursor: "pointer" }}
                            onClick={() => {
                                setOpen(false);
                                setMessages([]);
                                setMessage("");
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            padding: "10px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                        }}
                    >
                        {messages.length === 0 && message.trim() === "" ? (
                            <Box
                                sx={{
                                    marginTop: "40px",
                                    fontSize: { xs: "20px", sm: "32px" }, 
                                    fontWeight: 400,
                                    textAlign: "center",
                                    lineHeight: "100%"
                                }}
                            >
                                <span style={{ color: theme?.customSettings?.themeColor, display: "block" }}>Hey, {getUserName()}</span>
                                <span style={{ color: "#383432", display: "block" }}>what's on your mind today?</span>
                            </Box>



                        ) : (
                            messages.map((msg, idx) => (
                                <React.Fragment key={idx}>
                                    <Box
                                        sx={{
                                            alignSelf: msg.sender === "user" ? "flex-end" : "flex-start",
                                            backgroundColor: msg.sender === "user" ? "#F5F5F5" : "#FFFFFF",
                                            padding: "8px 12px",
                                            borderRadius: "100px",
                                            maxWidth: "80%",
                                            wordBreak: "break-word",
                                            color:"#383432",
                                            fontWeight:400,
                                            fontSize:"14px"
                                        }}
                                    >
                                        {msg.text}
                                    </Box>

                                    {msg.sender === "bot" && (
                                        <Box sx={{ display: "flex", gap: "15px", alignItems: "center", marginLeft:"12px" }}>
                                            <button style={{
                                               
                                                border: "none",
                                                borderRadius: "6px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                backgroundColor:"#FFFFFF",
                        
                                            }}
                                            ><LikeIcon style={{ width: "15px", height: "15px", fill:"#000000", stroke:"#000000", strokeWidth:2 }} /></button>
                                            <button style={{
                                                
                                                border: "none",
                                                borderRadius: "6px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                backgroundColor:"#FFFFFF",
                                              
                                            }}
                                            ><DislikeIcon style={{ width: "15px", height: "15px", fill:"#000000", stroke:"#000000", strokeWidth:2 }} /></button>
                                            <button style={{
                                                border: "none",
                                                borderRadius: "6px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                backgroundColor:"#FFFFFF",
                                                
                                            }}
                                            ><RefreshIcon style={{ width: "15px", height: "15px", fill:"#000000", stroke:"#000000", strokeWidth:2 }}/></button>
                                            <button style={{
                                                border: "none",
                                                borderRadius: "6px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                backgroundColor:"#FFFFFF",
                                            }}
                                            ><SpeakerIcon style={{ width: "15px", height: "15px", fill:"#000000", stroke:"#000000", strokeWidth:2 }} /></button>
                                        </Box>
                                    )}
                                </React.Fragment>
                            ))

                        )}
                    </Box>

                    <Box
                        sx={{
                            padding: "10px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                flex: 1,
                                height: { xs: "60px", sm: "94px" },
                                border: "1px solid #e0e0e0",
                                borderRadius: "20px",
                                padding: "8px 14px",
                                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                                backgroundColor: "#FFFFFF",
                            }}
                        >

                            <textarea
                                placeholder="Ask Ai Assistant"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                style={{
                                    flex: 1,
                                    border: "none",
                                    resize: "none",
                                    outline: "none",
                                    fontSize: "14px",
                                    lineHeight: "1.5",
                                    overflowWrap: "break-word",
                                    whiteSpace: "pre-wrap",
                                }}
                            />

                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: "8px",
                                        fontSize: "20px",
                                        cursor: "pointer",
                                        height: "14px",
                                        width: "14px",
                                        lineHeight: 1,
                                        color:"#000000"
                                    }}
                                >
                                    +
                                </Box>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginRight: "8px",
                                            fontSize: "20px",
                                            cursor: "pointer",
                                            height: "26px",
                                            width: "26px",
                                            lineHeight: 1,
                                            backgroundColor:"#FBE5D0",
                                            borderRadius:"50%"
                                        }}
                                    >
                                        <MicroPhoneIcon />
                                    </span>

                                    <span
                                        onClick={handleSend}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "24px",
                                            width: "24px",
                                            backgroundColor: "#000",
                                            borderRadius: "50%",
                                            cursor:"pointer"
                                        }}
                                    >
                                        <ArrowUpIcon
                                            style={{
                                                height: "18px",
                                                width: "18px",
                                                fill: "#FFFFFF",
                                            }}
                                        />
                                    </span>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            padding: "8px 14px",
                            textAlign: "center",
                            color: "#75716F",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "100%",
                            letterSpacing: "0"

                        }}
                    >
                        Ai Assistant may make mistakes. Using Ai Assistant means you agree to the Terms and Condition and Privacy Policy
                    </Box>

                </Box>
            )}

        </>
    )
}
export default PwcCopilot;